<div class="modal-content">
  <div class="modal-header">
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    <p class="modal-title h4" jhiTranslate="modals.changeOffer.title"></p>
  </div>
  <section id="section-offer">
    <div class="col-12 m-3">
      <div class="col-12 text-center">
        <ngx-spinner bdColor="rgba(0, 0, 0, 0.5)" size="default" color="#fff" type="ball-scale-multiple"><p class="text-white">Recherche des offres</p></ngx-spinner>
        <div class="text-center" *ngIf="!loadingData && offerEstimations.length === 0">
          <hr class="bary-hr" />
          <p>Pas de tarif disponible pour cette demande</p>
        </div>
        <div id="card-deck" class="" *ngIf="!loadingData && offerEstimations.length > 0">
          <div class="row justify-content-center">
            <div class="col-4 col-md-6 col-lg-4" *ngFor="let offerEstimation of offerEstimations">
              <jhi-bary-pricing-pack
                [offerEstimation]="offerEstimation"
                [isSelectedOffer]="offerEstimation.id === transport.offerId"
                (estimateEvent)="chooseOffer($event)"
              ></jhi-bary-pricing-pack>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
